import { FC } from 'react'
import useWindowSize from 'components/util/useWindowSize'
import RightRobotCard from '../cards/new/common/RightRobotCard'

type Props = {}

const LinkDevicesCard: FC<Props> = () => {
  const size = useWindowSize()
  return (
    <RightRobotCard
      image={{
        alt: 'Phone and Laptop with WhatsApp Business app',
        desktop: {
          dimensions: {
            height: 612,
            width: 523,
          },
          src: '/images/new/whatsapp/wa-devices.png',
        },
        mobile: {
          dimensions: {
            height: 612,
            width: 523,
          },
          src: '/images/new/whatsapp/wa-devices.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '38%' : '100%'}
      imageStyle={{
        maxWidth: '100%',
        objectFit: 'contain',
        height: '100%',
      }}
    >
      <div className='d-flex flex-column flex-1 px-4 pb-lg-24 pt-lg-13 ps-lg-20 pt-8 me-lg-n6'>
        <h2 className='fs-fluid-36-48 lh-105 fw-semibold mb-4 mb-lg-3'>
          Team efficiencies - link up to <strong>4 devices</strong> to your
          virtual phone number.
        </h2>
        <p className='fs-fluid-18-28 lh-32 lh-lg-119 fw-semibold'>
          Enable your teams and customer interactions more effectively by
          linking your teams to your central WhatsApp for Business virtual phone
          number from Hoxton Mix.
        </p>
        <p className='fs-fluid-16-18 lh-118 lh-lg-132 fw-semibold'>
          Connect up to 4 devices to your central number, and immediately enjoy
          the benefits in not just managing your customer's needs, but also how
          your teams operate and interact with each other. Driving operational
          efficiency with the WhatsApp Business platform creates a more cohesive
          team structure, improves operational efficiencies and most of all, it
          creates a coordinated support, sales and service capability even in
          the smallest of teams.
        </p>
      </div>
    </RightRobotCard>
  )
}

export default LinkDevicesCard
